<div class="w-full search-container p-0" style="width: 748px !important; height: max-content; overflow: hidden; min-height: 550px;">

  <div class="dialog-header-container txt-center">
    <div class="dialog-header-title">{{title}}</div>
    <div>
      <button mat-icon-button title="Close" class="app__close--icon" (click)="closeDialog();">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="form-group form-main form-group-overrides width-100per mb-0 col-span-2">
    <div class="div-group width-100per">

      <mat-form-field appearance="fill" id="access-manager-matAutoComplete" matTooltipClass="add-member-tooltip" class="white-background"
        [ngClass]="{ 'disable-search': disableSearch}">

        <div matPrefix class="mr-2 matPrefix-search-icon"><img src="../../../../assets/images/search-blue.svg" width="20px"
        height="19px" /></div>

        <input #inputField  type="text" matInput aria-label="Number" [formControl]="connectionUserFormControl"
          [placeholder]="textBoxPlaceHolder" class="addMember"
          (input)="onSearchValue($event.target.value)"/>

        </mat-form-field>
      </div>

      <div class="frame-overflow mt-6 mb-20">
        @if (data.length === 0 ) {
          <div class="grid grid-cols-1 gap-4">
            <div class="flex gap-4 py-5 h-fit fl-al-center ">
              <div class="flex" style="height: 84px; width: 84px;">
                <img src="assets/images/no-matchin-result.svg" />
              </div>
              <div style="color: #18191C;">
                <div class="font-semibold" style="font-size: 22px; margin-bottom: 8px; line-height: 24px;">No
                matching results to show</div>
                <div class="text-sm font-normal">Try changing the search terms, or add a new template</div>
              </div>
            </div>
          </div>
        }
        @if (data.length) {
          <div class="grid grid-cols-3 gap-4">
            @for (item of (data | manageTemplateTypeList : connectionUserFormControl.value); track item) {
<div [ngClass]="{
                              ' bg-[#EFFFF7] border-[#1AA140] border-[2px]': item.isSelected,
                              ' hover:rounded-xl hover:bg-[#EFFFF7] hover:border-[2px] hover:border-[#1AA140] hover:cursor-pointer': !item.isSelected
                            }" class="card-frame pointer d-flex fl-justify-center fl-al-center"
                (click)="onTempalteClick(item)">
                <div class="d-flex fl-col fl-al-center gap-2">
                  @if (item.isSelected) {
                    <img src="assets/images/discovery/selected.svg" height="68px" width="68px" />
                  }
                  @if (!item.isSelected) {
                    <img [src]="item?.img ?item?.img :item?.image" height="68px" width="68px" />
                  }
                  <div class="text-base font-semibold text-[#1E1E20] text-center ">{{item.type}}
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>


    <div class="footer-frame">
      <div class="d-flex fl-justify-end fl-al-center gap-6">

        <button class="frame-btn text-[#FFFFFF] text-xs font-semibold "
          [class.disable-button-continue]="isAddManuallyDisable"
        (click)="addManually()">Add</button>
      </div>
    </div>

  </div>